import { createSelector } from 'reselect'
import { initialState } from './slice'

type GlobalState = typeof initialState & { global: typeof initialState }
const selectGlobalState = (state: GlobalState) => state.global || initialState

export const selectMapBaseUrl = createSelector(selectGlobalState, state => state.mapBaseUrl)

export const selectMapZoomDelta = createSelector(selectGlobalState, state => state.mapZoomDelta)

export const selectPlatform = createSelector(selectGlobalState, state => state.platform)

export const selectStaticFilesUrl = createSelector(selectGlobalState, state => state.staticFilesUrl)

export const selectIsInitialized = createSelector(selectGlobalState, state => state.isInitialized)

export const selectIsGlobalLoading = createSelector(selectGlobalState, globalState => globalState.isGlobalLoading)

export const selectIsLoadingZones = createSelector(selectGlobalState, globalState => globalState.isLoadingZones)

export const selectIsLoadingGroups = createSelector(selectGlobalState, globalState => globalState.isLoadingGroups)

export const selectIsLoadingOrganizations = createSelector(
  selectGlobalState,
  globalState => globalState.isLoadingOrganizations,
)

export const selectIsLoadingUsers = createSelector(selectGlobalState, globalState => globalState.isLoadingUsers)

export const selectIsLoggingIn = createSelector(selectGlobalState, globalState => globalState.isLoggingIn)

export const selectCurrentUser = createSelector(selectGlobalState, globalState => globalState.currentUser)

export const selectAuthError = createSelector(selectGlobalState, globalState => globalState.authError)

export const selectAlerts = createSelector(selectGlobalState, globalState => globalState.alerts)

export const selectDashboardTransmissions = createSelector(
  selectGlobalState,
  globalState => globalState.dashboardTransmissions,
)

export const selectCurrentZone = createSelector(selectGlobalState, globalState => globalState.currentZone)

export const selectOrganizations = createSelector(selectGlobalState, globalState => globalState.organizations)

export const selectUsers = createSelector(selectGlobalState, globalState => globalState.users)

export const selectShowDataScience = createSelector(
  selectGlobalState,
  globalState => !(globalState.hiddenVerticals as string[]).includes('DATA_SCIENCE'),
)

export const selectAvailableZones = createSelector(selectGlobalState, globalState => globalState.availableZones)

export const selectAllGroups = createSelector(selectGlobalState, globalState => globalState.allGroups)
